/*
 * @Description:
 * @Author: 姜暖阳
 * @Date: 2021-07-08 15:10:26
 * @LastEditTime: 2023-10-08 11:45:34
 * @LastEditors: 赵大壮
 * @Reference:
 */
// 1. 请求 OK
// 2. get/post get转换拼接方式 post根据body等 OK
// 3. promise OK
// 4. 错误代码 OK
// 5. 服务端配置错误代码 OK
// 6. 不同服务器地址切换 OK
// 7. 图片/文件上传/下载 OK
// 8. mock

import request from './nyRequest'
import api from './nyApiJson'
import axios from 'axios'
import ny_config from './nyConfig'
import nyMessageToast from '../utils/NYMessageToast'
import store from '@/store'
import router from '@/router'
import { Loading } from 'element-ui';

class nyNet {
    install() {
        // 初始化调用
    }
    public net(apiName: string, parameter: { [key: string]: any } = {}, success: (response: any) => void) {
        var apiJson: ny_config = api[apiName];

        if (!apiJson) {
            console.error('未找到对应的网络接口 <' + apiName + ">");
            return;
        }

        var headers = null;

        store.state.user.updateCache();

        if (apiJson.useToken == true) {
            if (store.state.user.isLogin()) {
                headers = {
                    "Authorization": store.state.user.token,
                };
            }
        }

        var net_request = request({
            baseURL: apiJson.baseUrl,
            url: apiJson.url,
            method: 'post',
            data: parameter,
            timeout: apiJson.timeout, // 请求超时时间
            headers: headers,
        }).then(function (response: any) {
            if (response.code == -1008) {
                console.log('登录信息已被清除 = ', response);
                nyMessageToast.error('您的账号已在其他设备登录');
                store.commit("SET_USER", {});
                store.state.user.logout();
                router.push({ path: '/login' });
            }
            else if (response.code != 200) {
                if (apiJson.showFailMessage) {
                    if (response.msg) {
                        nyMessageToast.error(response.msg);
                    }
                    else {
                        console.log('response.message错误', response);
                    }
                }
                else {
                    console.log('请求失败但不提示信息，如需修改在nyApiJson中修改配置', response);
                }
            }
            else {
                if (apiJson.showSuccessMessage) {
                    if (response.msg) {
                        nyMessageToast.success(response.msg);
                    }
                    else {
                        console.log('response.message错误', response);
                    }
                }

                success(response.data);
            }
        })
            .catch(function (error) {
                if(!error.response){
                    console.log(error)
                    return
                }
                let trace = error.response.data.trace.match(/msg=(\S*),/)
                let status = error.response.data.status
                if(trace){
                    let msg = trace[1]
                    nyMessageToast.error(msg);
                }else{
                    nyMessageToast.error("系统错误，错误代码"+status);
                }
            });

        return net_request
    }
    public get(apiName: string, parameter: { [key: string]: any } = {}, success: (response: any) => void) {
        var apiJson: ny_config = api[apiName];
        if (!apiJson) {
            console.error('未找到对应的网络接口 <' + apiName + ">");
            return;
        }
        var headers = null;
        store.state.user.updateCache();
        if (apiJson.useToken == true) {
            if (store.state.user.isLogin()) {
                headers = {
                    "Authorization": store.state.user.token,
                };
            }
        }
        var net_request = request({
            baseURL: apiJson.baseUrl,
            url: apiJson.url,
            method: 'get',
            params: parameter,
            timeout: apiJson.timeout, // 请求超时时间
            headers: headers,
        }).then(function (response: any) {
            if (response.code == -1008) {
                console.log('登录信息已被清除 = ', response);
                nyMessageToast.error('您的账号已在其他设备登录');
                store.commit("SET_USER", {});
                store.state.user.logout();
                router.push({ path: '/login' });
            }
            else {
                success(response);
            }
        })
        .catch(function (error) {
            let trace = error.response.data.trace.match(/msg=(\S*),/)
            let status = error.response.data.status
            if(trace){
                let msg = trace[1]
                nyMessageToast.error(msg);
            }else{
                nyMessageToast.error("系统错误，错误代码"+status);
            }
        });
        return net_request
    }
    upload(apiName: string, parameter: { [key: string]: any } = {}, success: Function, progress: Function, error: Function) {
        let loadingInstance = Loading.service({
            lock: true,
            text: '上传中',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        });
        var apiJson = api[apiName];
        let formData = new FormData();
        for (const key in parameter) {
            formData.append(key, parameter[key]);
        }
        axios.defaults.withCredentials = false;
        const config = {
            headers: { "Content-Type": "multipart/form-data", "Authorization": store.state.user.token },
            onUploadProgress: function (e: any) {
                let percentage = Math.round((e.loaded * 100) / e.total) || 0
                console.log(e, percentage)
                progress(percentage);
            }
        };
        axios
            .post(process.env.VUE_APP_BaseURL + apiJson.url, formData, config)
            .then(function (response: any) {
                loadingInstance.close();
                console.log("response", response)
                if (response.status != 200) {
                    error();
                }
                else {
                    if (response.data.code == -1008) {
                        console.log('登录信息已被清除 = ', response);
                        nyMessageToast.error('您的账号已在其他设备登录');
                        store.commit("SET_USER", {});
                        store.state.user.logout();
                        router.push({ path: '/index' });
                    } else if (response.data.code != 200) {
                        error();
                    } else {
                        success(response.data.data);
                    }
                }
            })
            .catch(function (er) {
                loadingInstance.close();
                error();
                console.log("error", er);
            });
    }


    download(apiName: string, params: string) {
        var apiJson: ny_config = api[apiName];
        if (!apiJson) {
            console.error('未找到对应的网络接口 <' + apiName + ">");
            return;
        }
        var link = document.createElement('a');//a标签下载
        link.href = apiJson.baseUrl + apiJson.url + params;
        // link.download = name;
        link.click();
    }

    image(id: string) {
        if (!id) {
            return "";
        }
        var apiName = "显示图片";
        var apiJson: ny_config = api[apiName];
        if (!apiJson) {
            console.error('未找到对应的网络接口 <' + apiName + ">");
            return "";
        }
        return apiJson.baseUrl + apiJson.url + "?image=" + id;
    }

    video(id: string) {
        if (!id) {
            return "";
        }
        var apiName = "预览资源";
        var apiJson: ny_config = api[apiName];
        if (!apiJson) {
            console.error('未找到对应的网络接口 <' + apiName + ">");
            return "";
        }
        return apiJson.baseUrl + apiJson.url + "?id=" + id;
    }
}

const nyNetwork = new nyNet();

export default nyNetwork
